import { Box, Button, Stack } from "@mui/material";
import RefreshIcon from "@mui/icons-material/Refresh";
import SearchInput from "./SearchInput";
export default function FilterBar({
  search,
  onSearch,
  searchLabel,
  children,
  onReset,
  onRefresh,
  onExport,
  actions,
  loading,
}) {
  return (
    <Stack
      direction={{ xs: "column", md: "row" }}
      gap={1.5}
      flexWrap="wrap"
      alignItems={{ xs: "stretch", md: "center" }}
      sx={{ p: 2 }}
    >
      {onSearch && (
        <SearchInput
          value={search}
          onChange={onSearch}
          label={searchLabel}
          sx={{ minWidth: { md: 240 }, flex: { md: "1 1 240px" } }}
        />
      )}
      {children}
      {onReset && <Button onClick={onReset}>Clear filters</Button>}
      <Box sx={{ flexGrow: 1 }} />
      {onRefresh && (
        <Button
          startIcon={<RefreshIcon />}
          onClick={onRefresh}
          disabled={loading}
        >
          Refresh
        </Button>
      )}
      {onExport && (
        <Button onClick={onExport} disabled={loading}>
          Export
        </Button>
      )}
      {actions}
    </Stack>
  );
}
